<!-- 提交抗辩 -->
<template>
    <el-drawer
      title="我是标题"
      :visible.sync="visible"
      :direction="direction"
      :before-close="handleClose">
      <span>我来啦!</span>
    </el-drawer>
</template>

<script>
import AppealService from '@/views/transaction/api/appeal-manage.service';
export default {
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>

</style>
